import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { makeGetRequest } from '../../../../utils/api'
import { useSelector } from 'react-redux'
import { Bar, Doughnut, Line } from 'react-chartjs-2'
import moment from 'moment'
import 'moment/locale/fr'
import CloseIcon from '@mui/icons-material/Close'
import { setAppStore } from 'reduxLib/slices/mainAppSlice'
import { useDispatch } from 'react-redux'
import OperationFiTable from '../OperationFiTable'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function MesPassifs() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const dispatch = useDispatch()
  const params = useParams()
  const { slug } = params
  const getAppStore = useSelector((store) => store.appStore).appStore
  const [searchUrl, setSearchUrl] = useState('')
  const [data, setRevData] = useState(false)
  const [tempData, setTempRevData] = useState(false)

  useEffect(() => {
    if (searchUrl) fetchMesPassifs(searchUrl)
    console.log(searchUrl)
  }, [searchUrl])

  useEffect(() => {
    if (searchUrl) {
      if (getAppStore.type === 3) {
        if (getAppStore.fromDate) {
          setUrl(getAppStore)
        }
      } else {
        setUrl(getAppStore)
      }
    } else {
      if (getAppStore.type === 3) {
        if (getAppStore.fromDate) {
          setUrl(getAppStore)
        }
      } else {
        setUrl(getAppStore)
      }
    }
  }, [getAppStore])

  const setUrl = (store) => {
    setSearchUrl(
      `?type=${store.type}&fromDate=${store.fromDate}&toDate=${store.toDate}&viewType=${store.viewType}&chart=${store.chart}`,
    )
  }
  const fetchMesPassifs = async (url) => {
    const response = await makeGetRequest(`/api/Finance/dashboard-report/${slug}/` + url, {}, true)
    if (response.status === 200) {
      // setTempRevData({ labels: response.data.labels, datasets: response.data.datasets })

      // response.data?.labels.forEach((e) => {
      //   console.log(e)
      // })
      setRevData({ labels: response.data.labels, datasets: response.data.datasets })
    }
  }

  const optionsbar = {
    indexAxis: 'x',
    responsive: true,
    aspectRatio: 3.5,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: getAppStore.legend,

        position: 'right',
        labels: {
          boxWidth: 10,
          color: 'white',
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: 'white',
          callback: function (e) {
            return moment(data.labels[e]).format('MMM YY')
          },
        },
      },
      y: {
        stacked: true,
        ticks: { color: 'white' },
      },
    },
  }
  const optionsDout = {
    maintainAspectRatio: false,

    plugins: {
      clip: true,
      responsive: true,
      datalabels: {
        formatter: function (value, ctx) {
          let sum = data?.datasets[0].data.reduce((acc, cval) => acc + cval, 0)
          sum = parseFloat((value / sum) * 100).toFixed(2)
          return [
            ctx.chart.data.labels[ctx.dataIndex],
            value,
            sum + ' %'
          ]
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: getAppStore.legend,
        position: 'right',
        align: 'center',
        labels: {
          color: 'white',
        },
      },
    },
  }
  // const dd = {
  //   labels: [
  //     'Important et urgent',
  //     'Important et non urgent',
  //     'Non-important et urgent',
  //     'Non-important et non-urgent',
  //     'Non-important et non-urgent',
  //   ],
  //   datasets: [
  //     {
  //       label: 'Non démarré',
  //       data: [5, 6, 2, 6, 4],
  //       backgroundColor: ['#60829b'],
  //       borderColor: ['#60829b'],
  //       barThickness: 30,
  //     },
  //     {
  //       label: 'En cours',
  //       data: [6, 3, 4, 8, 8],
  //       backgroundColor: ['blue'],
  //       borderColor: ['blue'],
  //       barThickness: 30,
  //     },
  //     {
  //       label: 'En retard',
  //       data: [9, 6, 7, 9, 1],
  //       backgroundColor: ['red'],
  //       borderColor: ['red'],
  //       barThickness: 30,
  //     },
  //     {
  //       label: 'Terminées',
  //       data: [9, 6, 1, 1, 3],
  //       backgroundColor: ['green'],
  //       borderColor: ['green'],
  //       barThickness: 30,
  //     },
  //   ],
  // }
  return (
    <Grid container spacing={2}>
      {(getAppStore.table === 1 || getAppStore.table === 2) && (
        <Grid item xs={12}>
          <Box className={getAppStore.expandChart ? 'expand_chart' : 'height-500'} sx={{}}>
            {getAppStore.expandChart && (
              <CloseIcon
                onClick={() => dispatch(setAppStore({ expandChart: false }))}
                sx={{
                  color: 'white',
                  cursor: 'pointer',
                  position: 'absolute',
                  right: '60px',
                  top: '40px',
                }}
              />
            )}
            {getAppStore.chart === 1 && (
              <>
                {data?.labels ? (
                  <>
                    <Bar data={data} options={optionsbar} />
                  </>
                ) : (
                  <Box
                    color={'white'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    height={'100%'}
                  >
                    {t('dashboardDetail.noData')}
                  </Box>
                )}
              </>
            )}
            {getAppStore.chart === 2 && (
              <>
                {data?.labels ? (
                  <>
                    <Line data={data} options={optionsbar} />
                  </>
                ) : (
                  <Box
                    color={'white'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    height={'100%'}
                  >
                    {t('dashboardDetail.noData')}
                  </Box>
                )}
              </>
            )}
            {getAppStore.chart === 3 && (
              <>
                {data?.labels ? (
                  <>
                    <Doughnut data={data} options={optionsDout} />
                  </>
                ) : (
                  <Box
                    color={'white'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    height={'100%'}
                  >
                    {t('dashboardDetail.noData')}
                  </Box>
                )}
              </>
            )}
          </Box>
        </Grid>
      )}
      {(getAppStore.table === 1 || getAppStore.table === 3) && (
        <Grid item xs={12} mt={5}>
          <OperationFiTable url={searchUrl} />
        </Grid>
      )}
    </Grid>
  )
}

export default MesPassifs
